export const FormSvgIcon = () => (
  <svg
    width="76"
    height="76"
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.00003 67.5829C1.00321 66.2685 1.30426 64.9844 1.86593 63.859L32.6659 4.50703C32.6662 4.5064 32.6665 4.50578 32.6668 4.50515C33.2415 3.4123 34.0413 2.526 34.9763 1.9184C35.9102 1.31147 36.9511 1 38 1C39.0489 1 40.0898 1.31147 41.0237 1.9184C41.9585 2.52588 42.7582 3.41196 43.3328 4.50453C43.3333 4.50536 43.3337 4.5062 43.3341 4.50703L74.1309 63.8526C74.132 63.8548 74.1331 63.8571 74.1342 63.8593C74.6958 64.9846 74.9968 66.2686 75 67.5829C75.0032 68.8997 74.7072 70.1884 74.1488 71.3192C73.5906 72.4498 72.7943 73.3741 71.853 74.0134C70.9152 74.6504 69.8629 74.9852 68.7995 75H7.20053C6.13714 74.9852 5.08483 74.6504 4.147 74.0134C3.20572 73.3741 2.40944 72.4498 1.85117 71.3192C1.29278 70.1884 0.996831 68.8997 1.00003 67.5829Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M38.4492 26.1016L38.4492 53.1016"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M38.4492 59.2031H38.4856"
      stroke="black"
      stroke-width="6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
